export enum TabIndex {
  Details = 'details',
  Layers = 'layers',
  SecurityReport = 'securityreport',
  Packages = 'packages',
  ModelCard = 'modelcard',
}
